/**
 * PinnedNotesBand — Sawyer 11 client-notes-agreements (F1).
 *
 * On the client page's Pets / Grooming notes / Communication log / Activity
 * tabs the Staff notes panel is not on screen, so the pinned notes ride a
 * compact band under the profile header: the newest pin, and "+N more
 * pinned" which opens the Overview where the whole pinned group lives.
 * Renders nothing while loading, on failure, for roles without
 * `customers:read:all`, and when nothing is pinned (no empty band, P3).
 */
import type { JSX } from 'react';
import { ClientNotesDigest } from './ClientNotesDigest.js';
import { useClientNoteSignal } from './client-note-signals.js';

export interface PinnedNotesBandProps {
  readonly apiUrl: string;
  readonly customerId: string;
  /** Changes when the band should re-read (e.g. the active tab). */
  readonly refreshKey?: unknown;
  readonly onShowAllPinned: () => void;
}

export function PinnedNotesBand({
  apiUrl,
  customerId,
  refreshKey,
  onShowAllPinned,
}: PinnedNotesBandProps): JSX.Element | null {
  const { signal } = useClientNoteSignal(apiUrl, customerId, refreshKey);
  if (!signal || signal.pinned_total === 0) return null;
  return (
    <aside className="ferro-clientnotes-band" aria-label="Pinned client notes" data-testid="client-notes-pinned-band">
      <ClientNotesDigest
        pinned={signal.pinned}
        newNotes={[]}
        pinnedTotal={signal.pinned_total}
        unseenCount={0}
        customerId={customerId}
        mode="pinned-only"
        compact
        onShowAllPinned={onShowAllPinned}
        hideOpenClient
      />
    </aside>
  );
}
